import cx from 'classnames';
import PropTypes from 'prop-types';
import { BounceLoader } from '@bwoty-web/ui-kit';
import './loaderHeading.scss';

const LoaderHeading = ({ heading, topMargin }) => {
  if (!heading) {
    return null;
  }

  return (
    <div
      className={cx('iw-loader-heading', {
        'iw-loader-heading--top-margin': topMargin,
      })}
    >
      {heading}
      <BounceLoader className="iw-loader-heading__dots" />
    </div>
  );
};

LoaderHeading.propTypes = {
  heading: PropTypes.string.isRequired,
  topMargin: PropTypes.bool,
};

LoaderHeading.defaultProps = {
  topMargin: false,
};

export default LoaderHeading;
